/**
 * battleMaps — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {LANDSCAPE, tagline, chips, type ToilePack} from './data'

export const battleMapsPack: ToilePack = {
    slug: 'battle-maps',
    category: 'battlemap',
    name: 'Battle maps',
    tagline: tagline('maps', 'locations', 'renderings'),
    chips: chips('locations', 'renderings'),
    ratio: LANDSCAPE,
    readings: [
        {key: 'tavern', label: 'Tavern', subject: 'a village tavern common room, a bar, a hearth and scattered tables'},
        {key: 'forest', label: 'Forest ambush', subject: 'a dirt road through dense pine, a fallen log, boulders and a stream'},
        {key: 'crypt', label: 'Dungeon crypt', subject: 'stone chambers with sarcophagi, a collapsed corridor and an altar room'},
    ],
    styles: [
        {key: 'grid', label: 'Gridded', style: 'full color with a one-inch square grid overlaid', palette: 'flat even lighting', framing: 'orthographic overhead, whole play area'},
        {key: 'painterly', label: 'Painterly', style: 'gridless painted map, hand-painted stone and timber', palette: 'soft brushwork texture', framing: 'orthographic overhead, no grid lines'},
        {key: 'torchlit', label: 'Night torchlit', style: 'lit only by torches and braziers', palette: 'warm pools of light, deep blue shadow', framing: 'orthographic overhead, a faint grid'},
    ],
    directions: ['a ship deck instead', 'flooded and half-ruined', 'a bigger area'],
}
